module.exports = __webpack_public_path__ + "images/emoji/cactus.9cecb528241f31fcb920.png";